import React, { FC } from "react";
import BoosterRocket from "assets/icons/loyalty/booster_rocket.svg?react";
import LoyaltyBtnNext from "assets/icons/loyalty/arrow_next.svg?react";
import useTranslate from "hooks/useTranslate";
import classNames from "classnames";
import { Booster } from "types/Booster";
import { getTimeWord } from "utils/getTimeWord";
import "./styles.sass";

type LoyaltyBoosterButtonProps = {
  id?: string;
  booster: Booster;
  handleClick?: () => void;
  className?: string;
  isNext?: boolean;
  disabled?: boolean;
  mini?: boolean;
};

const LoyaltyBoosterButton: FC<LoyaltyBoosterButtonProps> = ({
  id,
  booster = { duration: 0, factor: 0 },
  handleClick,
  className,
  isNext = false,
  disabled,
  mini = false,
}) => {
  const { factor, duration } = booster;
  const t = useTranslate();
  const time = getTimeWord(t, Number(duration));

  const classNameButtonBooster = classNames(
    "LoyaltyBoosterButton",
    mini && "LoyaltyBoosterButton_mini",
    isNext && "LoyaltyBoosterButton_next",
    className,
  );

  const classNameText = classNames(
    "LoyaltyBoosterButton__text",
    isNext && "LoyaltyBoosterButton__text_next",
  );

  const classNameIcon = classNames(
    "LoyaltyBoosterButton__icon",
    isNext && "LoyaltyBoosterButton__icon_inactive",
    mini && "LoyaltyBoosterButton__icon_mini",
  );

  return (
    <button
      id={id}
      type="button"
      onClick={handleClick}
      className={classNameButtonBooster}
      disabled={disabled}
    >
      {isNext ? t("loyalty.modal.booster.nextBoost") : null}
      <BoosterRocket className={classNameIcon} />
      <div className="LoyaltyBoosterButton__content">
        {mini ? (
          <span className={classNameText}>
            {factor}x/{time}
          </span>
        ) : (
          <>
            <span className="LoyaltyBoosterButton__title">
              {t("loyalty.modal.booster.yourBoost")} {factor}x
            </span>
            <div className="LoayltyBoosterButton__subtitle">
              {t("loyalty.booster.btn.text")}
            </div>
          </>
        )}
      </div>
      {!mini && (
        <div className="LoayltyBoosterButton__arrow">
          <LoyaltyBtnNext />
        </div>
      )}
    </button>
  );
};

export default LoyaltyBoosterButton;
